import React, {useRef} from 'react';
import {SearchBar, useSearch} from '../../Components/Search';
import SearchForm from './SearchForm';

const Search = ({isLoading}) => {
    const {searchData, setSearchData} = useSearch();
    const submitRef = useRef();

    const form = <SearchForm data={searchData} updateSearch={setSearchData} submitRef={submitRef} clear />;

    return <SearchBar filterForm={form}
                isLoading={isLoading}
                modalOptions={{
                    title: 'Search contacts',
                    theme: 'primary',
                    icon: 'MagnifyingGlass',
                    initialFocus: submitRef,
                }}
            />
}

export default Search;
